import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
          <Container>
            <NavbarBrand tag={Link} to="/" title="Swami Brahmanand Saraswati" style={{color:"#fff",fontWeight:"bold"}}><img src="images/om.svg" alt="om" style={{width: "auto",height: "50px"}}/>स्वामी ब्रह्मानंद सरस्वती</NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <NavLink tag={Link} style={{fontWeight:"bold"}} to="/">मुख्य पृष्ठ</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link}  style={{fontWeight:"bold"}} to="/about">हमारे बारे में</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} style={{fontWeight:"bold"}} to="/timeline">जीवन यात्रा</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} style={{fontWeight:"bold"}} to="/services">सेवाएँ</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} style={{fontWeight:"bold"}} to="/gallery">गैलरी</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} style={{fontWeight:"bold"}} to="/events">कार्यक्रम</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} style={{fontWeight:"bold"}} to="/contact">संपर्क</NavLink>
                </NavItem>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
